<script setup lang="ts">
import { ref } from "vue";
import type { DialogProps } from "./dialog.types";
import { useDialog } from "./useDialog";

const props = withDefaults(defineProps<DialogProps>(), {
  open: false,
  modal: true,
  closeOnClickOutside: true,
  closeOnEscape: true,
  animated: true,
});

const contentRef = ref<HTMLDialogElement | null>(null);

const { classes, onBackdropClick } = useDialog({ props, contentRef });
</script>

<template>
  <!-- v-show is not used: native <dialog> manages its own visibility via .showModal()/.close() -->
  <dialog ref="contentRef" part="base" :class="classes" @click.self="onBackdropClick">
    <slot />
  </dialog>
</template>

<style>
:host {
  display: contents;
}

dialog {
  display: none;
  border: none;
  padding: 0;
  background: transparent;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
}

dialog[open] {
  display: flex;
}

dialog::backdrop {
  background: rgb(0 0 0 / 0.5);
  backdrop-filter: blur(12px);
}
</style>
